// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image__loading-backdrop[data-v-60ec0b8c]{opacity:.9;position:absolute;top:0;left:0;right:0;bottom:0;z-index:9;background:#eee}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
